import styled from 'styled-components';
import { Container } from './Container';

export const AppBarHeaderContainer = styled(Container)`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  height: ${props => props.theme.dimensions.navbarHeight};
`;
